<template>
  <KpiKorporatForm mode="Tambah" module="Indikator Kinerja"> </KpiKorporatForm>
</template>

<script>
import KpiKorporatForm from './form-kpi';
import { onBeforeRouteLeave } from 'vue-router';
import { useStore } from 'vuex';

const KpiKorporatAdd = {
  name: 'KpiKorporatAdd',
  components: { KpiKorporatForm },
  setup() {
    const store = useStore();
    onBeforeRouteLeave(() => {
      store.commit('axiosResetState');
    });
  },
};

export default KpiKorporatAdd;
</script>
